<template>
    <div>
        <div class="overlay"></div>

        <div class="popup-laterale popup-aggiungi-prezzo bg-white d-flex flex-column">
            <header role="navigation" class="navbar navbar-expand navbar-light">
                <nav class="flex-grow-1">
                    <div class="navbar-nav align-items-center text-uppercase">
                        <h3 class="text-light mb-0">
                            <font-awesome-icon :icon="['fas', 'tag']"/>
                            {{$t("Aggiungi elemento")}}
                        </h3>
                    </div>
                </nav>

                <a href="#" class="nav-link pr-2 pl-2 close-link">
                    <button type="button" class="close d-inline-flex align-items-center" aria-label="Close" @click="close(false)">
                        <font-awesome-icon :icon="['fas', 'times']"/>
                        <span class="d-none d-sm-inline ml-1 small font-weight-normal text-uppercase">{{$t("Chiudi")}}</span>
                    </button>
                </a>
            </header>

            <div class="container-fluid flex-grow-1">
                <ul class="elementi-da-aggiungere mb-0 mt-3">
                    <li class="elemento d-flex justify-content-between align-items-center py-1"
                        v-for="(article, index) in articlesList" :key="article.codArticolo"
                        :class="{'border-top': index > 0, 'selected': article.selected} ">
                        <div class="seleziona form-check px-1">
                            <input class="form-check-input m-0 position-static" type="checkbox"
                                   :checked="article.selected" :disabled="article.selected" @click="manageArticle($event, article)">
                        </div>
                        <div class="nome flex-grow-1 px-1">
                            {{article.nome}}
                        </div>
                        <div class="prezzo text-right px-1 font-weight-bold">
                            {{parseFloat(article.prezzo) | toCurrency}}
                        </div>
                    </li>
                </ul>
            </div>

            <footer class="bg-light mt-3 py-3">
                <div class="container-fluid">
                    <div class="d-flex justify-content-end flex-wrap align-items-center">
                        <a class="btn btn-dark btn-rikorda2-alt" @click="close(false)">
                            {{$t("Annulla")}}
                        </a>
                        <a href="#" class="btn btn-dark btn-rikorda2-alt ml-1" @click="saveArticles">
                            {{$t("Aggiungi al listino")}}
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PricelistArticlesModal",
        props: ["pricelistId"],

        data() {
            return {
                categoryId: "",
                articlesList: [],
                articlesToAdd: [],
                articlesToRemove: [],
            };
        },

        methods: {
            loadArticles() {
                this.articlesList = [];
                this.articlesToAdd = [];
                this.articlesToRemove = [];
                return this.$api.backendGetPricelistCategoryArticles(this.pricelistId, this.categoryId)
                    .then((data) => {
                        this.articlesList = data.articlesList;
                        return true;
                    })
                    .catch(error => {
                        console.error(error);
                        return false;
                    });
            },

            manageArticle($event, article) {
                var index, checked = $event.target.checked;
                var articleCode = article.codArticolo;

                if (article.selected) {
                    if (checked) {
                        index = this.articlesToRemove.indexOf(articleCode);
                        if (index > -1) {
                            this.articlesToRemove.splice(index, 1);
                        }
                    } else {
                        this.articlesToRemove.push(articleCode);
                    }
                } else {
                    if (checked) {
                        this.articlesToAdd.push(articleCode);
                    } else {
                        index = this.articlesToAdd.indexOf(articleCode);
                        if (index > -1) {
                            this.articlesToAdd.splice(index, 1);
                        }
                    }
                }
            },

            saveArticles() {
                if (this.articlesToAdd.length > 0 || this.articlesToRemove.length > 0) {
                    var articles = {"add": this.articlesToAdd, "remove": this.articlesToRemove};
                    return this.$api.backendSavePricelistCategoryArticles(this.pricelistId, this.categoryId, articles)
                        .then((response) => {
                            this.close(true);
                        })
                        .catch(error => {
                            console.error(error);
                        });
                } else {
                    this.close(false);
                }
            },

            close(updatePricelist) {
                this.categoryId = "";
                this.articlesList = [];
                this.articlesToAdd = [];
                this.articlesToRemove = [];
                this.$emit("close", {updatePricelist: updatePricelist});
            },
        }
    };
</script>

<style></style>
